export enum EnvironmentType {
    Local = "local",
    Test = "test",
    Demo = "demo",
    QA = "qa",
    Prod = "prod"
}

export type Webapp = Readonly<{
    domainUrl: string
    baseUrl: string
    desktopUrl: string
}>

export type Api = Readonly<{
    baseUrl: string
}>

export type Environment = Readonly<{
    type: EnvironmentType
    webapp: Webapp
    api: Api
}>


export type CurrentApp = Readonly<{
    version: string
}>

export type CurrentWebapp = Readonly<{
    webappOnlyUrl: string | undefined
    baseUrl: string
    desktopUrl: string
    version: string
    versionFull: string
    deployPath?: string
    deployTime?: string
}>

export type CurrentApi = Readonly<{
    baseUrl: string
    gateUrl: string
}>

export type CurrentEnvironment = Readonly<{
    type: EnvironmentType
    app?: CurrentApp
    webapp?: CurrentWebapp
    api: CurrentApi
    device: any
}>

export type EnvironmentMap = Record<EnvironmentType, Environment>

export type EnvironmentState = Readonly<{
    current: CurrentEnvironment
}>

export type EnvironmentStore = Readonly<{
    environment: EnvironmentState
}>
